var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log-activity-user",class:{'log-activity-user--full': !_vm.is_sidebar_minimized}},[_c('j-log-activity-aside'),_vm._v(" "),_c('div',{staticClass:"log-activity-user__content"},[_c('j-log-activity-login')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-786fad5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/log-activity/jLogActivity.vue
// module id = null
// module chunks = 